import {
  MessageCircle,
  Instagram,
  Facebook,
  MessageSquare,
  MessageSquareText,
  FileText,
  Users,
  Shield,
  UserPlus,
  Activity,
  Plug,
  User
} from 'lucide-react';

export const buildNavigationItems = ({
  canManageTemplates = false,
  canViewUserRoster = false,
  canManagePositions = false,
  canManageTeams = false,
  canInviteUsers = false,
  canViewStats = false,
  canManageIntegrations = false,
  canModerateComments = false
} = {}) => {
  const items = [
    { id: 'inbox', label: 'Direct Messages', icon: MessageCircle, to: '/inbox', exact: true },
    // { id: 'instagram', label: 'Instagram', icon: Instagram, to: '/inbox/instagram' }, // disabled
    // { id: 'facebook', label: 'Facebook', icon: Facebook, to: '/inbox/facebook' }, // disabled
    // WhatsApp is intentionally hidden until the channel is implemented.
  ];

  if (canModerateComments) {
    items.push({ id: 'comments', label: 'Comments & Reviews', icon: MessageSquare, to: '/comments' });
  }

  if (canManageIntegrations) {
    items.push({
      id: 'manage-pages',
      label: 'Manage connected pages',
      icon: Plug,
      type: 'manage-pages',
      menuItems: [
        { id: 'instagram', label: 'Manage Instagram', icon: Instagram },
        { id: 'facebook', label: 'Manage Facebook', icon: Facebook },
        { id: 'whatsapp', label: 'Manage WhatsApp', icon: MessageCircle, superAdminOnly: true }
      ]
    });
  }

  if (canManageTemplates) {
    items.push({ id: 'templates', label: 'Templates', icon: FileText, to: '/templates' });
    items.push({ id: 'quick-replies', label: 'Quick Replies', icon: MessageSquareText, to: '/quick-replies' });
  }

  // items.push({ id: 'profile', label: 'My Profile', icon: User, to: '/profile' }); //profile page disabled

  if (canViewStats) {
    items.push({ id: 'stats', label: 'Analytics', icon: Activity, to: '/stats' });
  }

  if (canViewUserRoster) {
    items.push({ id: 'user-directory', label: 'User Directory', icon: Users, to: '/user-directory' });
  }

  if (canInviteUsers) {
    items.push({ id: 'create-user', label: 'Create User', icon: UserPlus, to: '/admin/users/new' });
  }

  if (canManagePositions) {
    items.push({ id: 'positions', label: 'Positions', icon: Shield, to: '/positions' });
  }

  if (canManageTeams) {
    items.push({ id: 'teams', label: 'Team Members', icon: Users, to: '/teams' });
  }

  return items;
};
